export default __webpack_public_path__ + "static/media/Resolucion_17_acta_62_tasas_de_interes.79c4939a.pdf";